import * as THREE from "../../build/three.module.js";
import { OrbitControls } from "../../examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "../../examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "../../examples/jsm/postprocessing/EffectComposer.js";
import { TWEEN } from "../../examples/jsm/libs/tween.module.min.js";
import { Water } from "../../examples/jsm/objects/Water.js";

class ThreeDimensional {

    constructor(divName, isAlpha = false) {
        const scope = this;
        //画布
        this.canvas = null;
        //摄像机
        this.camera = null;
        //场景
        this.scene = null;
        //渲染器
        this.renderer = null;
        //控制器
        this.controls = null;
        //特效图层
        this.composer = null;
        //环境反射贴图
        this.environment = null;
        //鼠标按下的位置
        this.mouseDownPos = null;
        this.outlinePass = null;
        this.effectFXAA = null;
        this.raycaster = null;
        this.renderPass = null;
        this.ZincWater = null;
        //画布与屏幕边界的距离，用于后续嵌入UI界面导致画布大小改变射线不准确
        this.canvasOffset;
        this.Intensity = 0
        //天空盒
        this.skyBox = null;
        this.WorkShop = null;
        this.divArray = [];
        this.divLabel = [];
        this.animateID = null;
        this.spriteMain = null;
        this.labelRenderer_2d = null;
        this.labelRenderer_3d = null;
        this.Model = null;
        this.clock = null;
        this.delta = null;
        this.AnimationTime = 0;
        this.mixer = null;
        this.action = null;
        this.CameraAnimation = null;
        this.allGroup = [];
        this.clickBox = null;
        this.cubeArray = [];
        this.PointPos = { x: 0, y: 0 };
        this.ModelSize = [523756, 697416, 259168, 4315012, 4315048, 370408, 242692, 1524944, 748300, 1813680, 3198304, 418624, 115876, 8284];
        this.ConveyorBeltUV = [];
        this.ConveyorBeltUV_2 = [];
        this.ConveyorBeltUV_3 = [];
        this.ConveyorBeltUV_4 = [];
        this.gangTieMaterial = [];
        this.InfoBoxArray = [];
        this.initPos = {};
        this.isAloneModel = false;
        this.LastShowIndex = null;
        //在变成透明前，保存现有材质
        this.OldMaterial = [];
        this.InfoBoxImg = [];
        //信息框精灵
        this.KJJSprite = null;
        this.XRSJRLSprite = null;
        this.THLSprite = null;
        this.AOISprite = null;
        this.JQJSprite = null;
        this.TMaterial = null;
        this.isRoaming = false;
        this.isControls = false;
        this.AllLoaderCount = 14;

        let AloneCamera = [];
        AloneCamera[3] = { x: 19.359551610758015, y: 7.78087840313741, z: -50.7090360279763 };
        AloneCamera[4] = { x: 20.41742707287463, y: 7.171105193083897, z: 55.16342031615985 };
        AloneCamera[6] = { x: -19.99639071489485, y: 13.370488769386355, z: -34.19465534917586 };
        AloneCamera[9] = { x: 27.57646593368125, y: 12.844302479195417, z: 54.276385992458515 };
        AloneCamera[10] = { x: 29.908339568432513, y: 11.25419479080845, z: 11.64761706003755 };

        let AloneControls = [];
        AloneControls[3] = { x: -1.225164011477783, y: 6.4125021733345315, z: -65.33468267548216 };
        AloneControls[4] = { x: 2.0013711831332603, y: 6.677461061242155, z: 64.37595886654148 };
        AloneControls[6] = { x: 1.175071259955042, y: 12.485180955580926, z: -61.29592224508174 };
        AloneControls[9] = { x: -0.9429115205903069, y: 11.70227559249478, z: 38.35647604276813 };
        AloneControls[10] = { x: 0.01701476292812955, y: 12.009533755861991, z: 3.2869469447294515 };

        let timgTexture = new THREE.TextureLoader().load('./img/timg.jpg')
        timgTexture.wrapS = THREE.RepeatWrapping
        timgTexture.wrapT = THREE.RepeatWrapping
        timgTexture.repeat.x = 1;
        timgTexture.repeat.y = 1;

        let boxTexture = new THREE.TextureLoader().load('./img/box.png')
        boxTexture.wrapS = THREE.RepeatWrapping
        boxTexture.wrapT = THREE.RepeatWrapping
        boxTexture.repeat.x = 1;
        boxTexture.repeat.y = 1;

        Start();
        /**
         * @烁滔老公
         * Start函数
         * 初始时调用一次
         */
        function Start() {
            //加载信息框背景
            LoadImg("img3");
            LoadImg("img5");
            //初始化场景
            onLoad();
            LoadEnvironmentTexture();
            LoadSceneTexture();

            //循环加载模型
            for (let i = 0; i <= 13; i++) {
                //https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/steelannealingfurnace/0.glb
                LoadGLBModel('https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/steelannealingfurnace/' + i + '.glb', i);
            }

            //加载漫游动画
            LoadCameraAnimation();
            //初始化透明材质
            scope.TMaterial = new THREE.MeshStandardMaterial({
                map: boxTexture,
                color: 0x79AFF5,
                transparent: true,
                opacity: 0.4,
                depthWrite: false,
                reflectivity: 0,
            })

            //创建信息面板
            scope.KJJSprite = CloneSprites({ x: 10, y: 6 }, { x: -1, y: 5, z: 65.7 });
            scope.InfoBoxArray[4] = scope.KJJSprite;

            scope.XRSJRLSprite = CloneSprites({ x: 10, y: 6 }, { x: -1, y: 15, z: 37.9 });
            scope.InfoBoxArray[9] = scope.XRSJRLSprite;

            scope.THLSprite = CloneSprites({ x: 10, y: 6 }, { x: -1, y: 15, z: 2.5 });
            scope.InfoBoxArray[10] = scope.THLSprite;

            scope.AOISprite = CloneSprites({ x: 10, y: 8 }, { x: -1, y: 12, z: -58.7 });
            scope.InfoBoxArray[6] = scope.AOISprite;

            scope.JQJSprite = CloneSprites({ x: 10, y: 6 }, { x: -1, y: 5, z: -65 });
            scope.InfoBoxArray[3] = scope.JQJSprite;
        }

        /**
         * @烁滔老公
         * 初始加载
         * 初始化画布
         * 初始化场景
         * 初始化渲染器
         * 初始化摄像机
         * 初始化控制器
         * 初始化特效通道
         */
        function onLoad() {

            //获取画布
            scope.canvas = document.getElementById(divName);
            scope.canvasOffset = document.getElementById(divName);

            //初始化场景
            scope.scene = new THREE.Scene();

            //初始化渲染器
            scope.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: isAlpha,
            });
            scope.renderer.setPixelRatio(window.devicePixelRatio);
            scope.renderer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);

            //添加画布到div
            scope.canvas.appendChild(scope.renderer.domElement);

            //初始化摄像机
            scope.camera = new THREE.PerspectiveCamera(60, scope.canvas.clientWidth / scope.canvas.clientHeight, 0.1, 10000);

            //添加环境灯光
            const light = new THREE.AmbientLight(0xffffff, 1.5); // soft white light
            scope.scene.add(light);


            //初始化特效图层通道
            scope.composer = new EffectComposer(scope.renderer);
            scope.raycaster = new THREE.Raycaster();
            //初始化时钟
            scope.clock = new THREE.Clock();

            //创建锌水
            const waterGeometry = new THREE.PlaneGeometry(4, 4);
            scope.ZincWater = CretaeWater(waterGeometry);
            scope.ZincWater.position.set(-1, -0.1, -40.8)
            scope.ZincWater.rotation.x = - Math.PI / 2;
            scope.scene.add(scope.ZincWater)
            scope.allGroup[15] = scope.ZincWater;
            scope.ZincWater.material.uniforms.distortionScale.value = 1;
            scope.ZincWater.material.uniforms.size.value = 200;

            //创建网格地面
            let PlaneTexture = new THREE.TextureLoader().load('./img/Plane.png')
            PlaneTexture.wrapS = THREE.RepeatWrapping
            PlaneTexture.wrapT = THREE.RepeatWrapping
            PlaneTexture.repeat.x = 100;
            PlaneTexture.repeat.y = 100;
            const PlaneGeometry = new THREE.PlaneGeometry(4000, 4000);
            const PlaneMaterial = new THREE.MeshBasicMaterial({
                map: PlaneTexture,
                transparent: true,
                color: 0xA0D9FB,
                reflectivity: 0.1
            });
            const Plane = new THREE.Mesh(PlaneGeometry, PlaneMaterial);
            Plane.rotation.set(-0.5 * Math.PI, 0, 0);
            Plane.position.set(0, -1.6, 0)
            scope.allGroup[16] = Plane;
            scope.scene.add(Plane);

            //创建精灵
            scope.spriteMain = new THREE.Sprite();

            //初始化控制器            
            scope.controls = CretaeControls(scope.renderer.domElement, true);

            //添加动态响应函数
            window.addEventListener("resize", onWindowResize);

            window.addEventListener('mouseup', onMouseUp, false);
            window.addEventListener('mousedown', onMouseDown, false);

            update();
        }

        this.GetPosition = () => {
            return scope.PointPos;
        }

        function onWindowResize() {
            scope.onWindowResize();
        }

        //克隆精灵
        function CloneSprites(scale, position) {
            let cloneSprite = scope.spriteMain.clone();
            cloneSprite.center = new THREE.Vector2(0.5, 0);
            cloneSprite.position.set(position.x, position.y, position.z);
            cloneSprite.scale.set(scale.x * 1.8, scale.y * 1.8);
            scope.scene.add(cloneSprite);
            return cloneSprite;
        }

        function random(value, min, max) {
            return (value + ((Math.floor(Math.random() * (max - min)) + min) / 100)).toFixed(2);
        }



        this.UpdateData = () => {
            setInterval(() => {
                if (Object.keys(scope.InfoBoxImg).length >= 2) {
                    RandomData();
                }
            }, 2000)
        }

        function RandomData() {

            creatCanvas("img3", ['开卷机', '设备状态：', '输送线设定转速：', '输送线转速反馈：'], ['启动', '21r/min', random(21, -120, 120) + 'r/min'], scope.KJJSprite);

            creatCanvas("img3", ['无氧化蓄热式加热炉', '炉温：', '蓄热体顶部温度：', '输送线转速反馈：'], [random(1200, -120, 120) + '℃', random(1200, -120, 120) + '℃', random(21, -120, 120) + 'r/min'], scope.XRSJRLSprite);

            creatCanvas("img3", ['辐射式退火炉', '规格：', '退火温度：', '屈服强度：'], ['0.5*1268BLC-JD3', random(670, -120, 120) + '℃', random(255, -120, 120) + 'Mpa'], scope.THLSprite);
            // 
            creatCanvas("img5", ['AI视觉检测', '当前检查材质：', '预计检测：', '剩余检测：', '质量检测数量：', '合格率：'], ['0.5*1268BLC-JD3', random(5.5, -120, 120) + 't', random(3, -120, 120) + 't', random(3, -120, 120) + 't', random(98, -120, 120) + '%'], scope.AOISprite);
            // 
            creatCanvas("img3", ['卷取机', '设备状态：', '输送线设定转速：', '输送线转速反馈：'], ['启动', '21r/min', random(21, -120, 120) + 'r/min'], scope.JQJSprite);
        }


        /**
         * 设置信息面板数据函数
         * 将传入datas，datas可根据自身情况传入，并将数据填入下方数组内
         * @param {object?} datas 
         */
        this.SetInfoData = (datas) => {

            creatCanvas("img3", ['开卷机', '设备状态：', '输送线设定转速：', '输送线转速反馈：'], ['启动', '21r/min', random(21, -120, 120) + 'r/min'], scope.KJJSprite);

            creatCanvas("img3", ['无氧化蓄热式加热炉', '炉温：', '蓄热体顶部温度：', '输送线转速反馈：'], [random(1200, -120, 120) + '℃', random(1200, -120, 120) + '℃', random(21, -120, 120) + 'r/min'], scope.XRSJRLSprite);

            creatCanvas("img3", ['辐射式退火炉', '规格：', '退火温度：', '屈服强度：'], ['0.5*1268BLC-JD3', random(670, -120, 120) + '℃', random(255, -120, 120) + 'Mpa'], scope.THLSprite);
            // 
            creatCanvas("img5", ['AI视觉检测', '当前检查材质：', '预计检测：', '剩余检测：', '质量检测数量：', '合格率：'], ['0.5*1268BLC-JD3', random(5.5, -120, 120) + 't', random(3, -120, 120) + 't', random(3, -120, 120) + 't', random(98, -120, 120) + '%'], scope.AOISprite);
            // 
            creatCanvas("img3", ['卷取机', '设备状态：', '输送线设定转速：', '输送线转速反馈：'], ['启动', '21r/min', random(21, -120, 120) + 'r/min'], scope.JQJSprite);
        }

        function creatCanvas(imgName, title, msg, sprite) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            let w = scope.InfoBoxImg[imgName].width;
            let h = scope.InfoBoxImg[imgName].height;
            canvas.width = w * 4;
            canvas.height = h * 4;
            ctx.drawImage(scope.InfoBoxImg[imgName], 0, 0, w * 4, h * 4);

            ctx.textBaseline = 'middle';
            ctx.scale(4, 4);
            ctx.fillStyle = '#FFF';

            ctx.font = '16px siYuan';
            ctx.textAlign = 'left';
            ctx.fillText(title[0], 20, h / ((title.length - 0.5) * 2));

            ctx.font = '15px siYuan';
            ctx.textAlign = 'center';
            for (let i = 1; i < title.length; i++) {
                if (i == 1) {
                    ctx.fillText(title[i], w / 3.5, 83);
                } else {
                    ctx.fillText(title[i], w / 3.5, i * 40 + 40);
                }
            }
            ctx.font = '15px siYuan';
            ctx.textAlign = 'left';
            ctx.fillStyle = '#ffffff';
            var gradient = ctx.createLinearGradient(0, 0, w / 4, 0);
            gradient.addColorStop('0', '#ffffff');
            gradient.addColorStop('1.0', '#00dbff');
            ctx.fillStyle = gradient;
            for (let i = 0; i < msg.length; i++) {
                if (i == 0) {
                    ctx.fillText(msg[i], w / 1.8, 83);
                } else {
                    ctx.fillText(msg[i], w / 1.8, (i + 1) * 40 + 40);
                }
            }

            var texture = new THREE.Texture(canvas);
            texture.needsUpdate = true;
            sprite.material.dispose();
            sprite.material = new THREE.SpriteMaterial({
                map: texture,
                //sizeAttenuation : false
            });

        }

        //鼠标按下时，记录当前鼠标坐标
        function onMouseDown(event) {
            scope.mouseDownPos = event;
            scope.isControls = true;
        }

        //鼠标抬起时
        function onMouseUp(event) {
            scope.isControls = false;
            scope.AnimationTime = 0;
            //当鼠标按下与抬起时坐标一致，再判定为点击
            if (scope.mouseDownPos.clientX == event.clientX || scope.mouseDownPos.clientY == event.clientY) {
                let canvasoffsetLeft = scope.canvas.offsetLeft;
                let canvasoffsetTop = scope.canvas.offsetTop;
                let newX = event.clientX - canvasoffsetLeft;
                let newY = event.clientY - canvasoffsetTop;
                if (event.clientX <= (canvasoffsetLeft + scope.canvas.clientWidth) && event.clientX >= canvasoffsetLeft &&
                    event.clientY >= canvasoffsetTop && event.clientY <= (canvasoffsetTop + scope.canvas.clientHeight)) {
                    //鼠标坐标
                    var mousePos = new THREE.Vector2();
                    //通过鼠标点击的位置计算出raycaster所需要的点的位置，以屏幕中心为原点，值的范围为-1到1.
                    mousePos.x = (newX / scope.canvas.clientWidth) * 2 - 1;
                    mousePos.y = -(newY / scope.canvas.clientHeight) * 2 + 1;
                    OnRayCaster(mousePos, event);
                }
            } else {
                scope.mouseDownPos = event;
            }

            //当操作了界面，停止漫游
            if (scope.isRoaming) {
                scope.StopCameraAnimation();
            }
        }

        /**
         * 传入模型索引
         * @param {int} index 
         */
        function SetOtherObjVisible(index) {

            scope.allGroup.forEach(item => {
                item.visible = false;
            });
            scope.clickBox.traverse(child => {
                if (child.isMesh) {
                    child.layers.set(1);
                }
            })
            scope.InfoBoxArray.forEach(item => {
                item.visible = false;
            });

            scope.allGroup[index].visible = true;

            scope.InfoBoxArray[index].visible = true;

            scope.initPos = {
                initCamera: { x: scope.camera.position.x, y: scope.camera.position.y, z: scope.camera.position.z },
                initControls: { x: scope.controls.target.x, y: scope.controls.target.y, z: scope.controls.target.z }
            }
            SetTransparent(index);
            MoveCamera(AloneCamera[index], AloneControls[index], 2000);
            //scope.controls.autoRotate = true;
            //ShowclickMianShowButton();
            scope.isAloneModel = true;

        }

        //将材质设为透明模式
        function SetTransparent(index) {
            if (index == 9 || index == 10) {
                scope.LastShowIndex = index;
                // //记录上一次的材质
                scope.OldMaterial = [];
                scope.allGroup[index].traverse(function (child) {
                    if (child.isMesh) {
                        scope.OldMaterial[child.name] = child.material;
                        if (child.name.indexOf("_n") == -1) {
                            child.material = scope.TMaterial;
                        }
                    }
                });
            }
        }

        //将透明材质换回以往材质
        function SetOldMaterial() {
            if (scope.LastShowIndex == null) {
                return;
            }
            let index = 0;
            scope.allGroup[scope.LastShowIndex].traverse(function (child) {
                if (child.isMesh) {
                    if (child.name.indexOf("_n") == -1) {
                        child.material = scope.OldMaterial[child.name];
                        index++;
                    }
                }
            });
            scope.LastShowIndex = null;
            scope.OldMaterial = [];
        }

        //显示所有模型
        this.ShowAllModel = () => {
            scope.allGroup.forEach(item => {
                item.visible = true;
            });
            scope.InfoBoxArray.forEach(item => {
                item.visible = true;
            });
            scope.clickBox.traverse(child => {
                if (child.isMesh) {
                    child.layers.set(0);
                }
            })
            MoveCamera(scope.initPos.initCamera, scope.initPos.initControls, 2000);
            SetOldMaterial();
            scope.isAloneModel = false;
        }


        //点击 射线操作
        function OnRayCaster(mousePos) {
            // 通过鼠标点的位置和当前相机的矩阵计算出raycaster
            scope.raycaster.setFromCamera(mousePos, scope.camera);
            // 获取raycaster直线和所有模型相交的数组集合
            var intersects = scope.raycaster.intersectObjects(scope.clickBox.children, true);
            if (intersects.length > 0) {
                let selectObjects = [];
                selectObjects.push(intersects[0].object);
                //打印点击到的物体
                //漫游时，不可单独查看
                if (!scope.isRoaming) {
                    SetOtherObjVisible(parseInt(selectObjects[0].name));
                }

            } else {
                //没有点击到物体
                if (scope.isAloneModel) {
                    scope.ShowAllModel();
                }
            }
        }

        //窗口监听，根据当前窗口大小，自适应调整
        this.onWindowResize = () => {
            scope.camera.aspect = scope.canvas.clientWidth / scope.canvas.clientHeight;
            scope.camera.updateProjectionMatrix();
            scope.renderer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);
            scope.composer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);
        }

        /**
         * @乾斌宝宝
         * 加载设备模型函数
         */
        let nowLoader = 0;
        function LoadGLBModel(url, index = 0) {
            let loader = new GLTFLoader();
            loader.load(url, function (model) {
                model.scene.traverse(function (child) {
                    if (child.isMesh) {
                        if (child.name == 'liudong' || child.name == 'liudong_n') {
                            scope.ConveyorBeltUV.push(child.material.map)
                        }
                        if (child.name == 'gangdai' || child.name == 'gangdai_n') {
                            scope.gangTieMaterial.push(child.material);
                        }
                        if (child.name == 'zhifaguang' || child.name == 'zhifaguang_n') {
                            scope.gangTieMaterial.push(child.material);
                        }
                        child.material.envMap = scope.environment;
                    }
                })
                if (index == 13) {
                    model.scene.visible = false;
                    scope.clickBox = model.scene;
                } else {
                    scope.allGroup[index] = model.scene;
                }
                scope.scene.add(model.scene);
                scope.Model = model.scene;
            }, function (xhr) {
                if ((xhr.loaded / scope.ModelSize[index]) == 1) {
                    nowLoader += 1;

                    GetModelLoader(((nowLoader / scope.AllLoaderCount) * 100).toFixed(2));
                }
            })
        }

        //加载相机漫游动画
        function LoadCameraAnimation() {
            let loader = new GLTFLoader();
            loader.load('https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/steelannealingfurnace/cameraAnimationglb.glb', function (model) {

                scope.scene.add(model.scene);
                scope.CameraAnimation = model.scene;
                scope.mixer = new THREE.AnimationMixer(model.scene);
                scope.action = scope.mixer.clipAction(model.animations[0]);

            });
        }

        /**
         * 调用该函数，即可播放漫游动画
         */
        this.PlayCameraAnimation = () => {
            scope.initPos = {
                initCamera: { x: scope.camera.position.x, y: scope.camera.position.y, z: scope.camera.position.z },
                initControls: { x: scope.controls.target.x, y: scope.controls.target.y, z: scope.controls.target.z }
            };

            let v3 = new THREE.Vector3();
            scope.CameraAnimation.children[0].getWorldPosition(v3);
            let q3 = new THREE.Quaternion();
            scope.CameraAnimation.children[0].getWorldQuaternion(q3);
            scope.camera.setRotationFromQuaternion(q3);
            scope.camera.position.set(v3.x, v3.y, v3.z);
            scope.CameraAnimation.children[0].attach(scope.camera);

            scope.action.timeScale = 0.5;
            scope.action.play();
            scope.isRoaming = true;
        }

        //停止漫游
        this.StopCameraAnimation = () => {
            scope.action.stop();
            scope.scene.attach(scope.camera);

            //回到漫游前视角
            //MoveCamera(scope.initPos.initCamera, scope.initPos.initControls, 2000);
            //回到初始视角
            MoveCamera({ x: 68.73, y: 28.75, z: 2.98 }, { x: -5.46, y: 4.27, z: 1.39 }, 2000);
            scope.isRoaming = false;
        }

        //创建锌水动效
        function CretaeWater(geometry) {
            let water = new Water(
                geometry,
                {
                    textureWidth: 512,
                    textureHeight: 512,
                    waterNormals: new THREE.TextureLoader().load('./img/waternormals.jpg', function (texture) {
                        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                    }),
                    waterColor: 0xffffff,
                    //distortionScale: 3.7,
                    fog: scope.scene.fog !== undefined
                }
            );
            water.material.uniforms.size.value = 2;

            return water;
        }

        /**
         * 创建控制器
         */
        function CretaeControls(domElement, enable) {
            let controls = new OrbitControls(scope.camera, domElement);
            controls.enableDamping = true;
            controls.minDistance = 0;
            controls.maxDistance = 75;
            controls.enabled = enable;
            scope.camera.position.set(68.73, 28.75, 2.98);
            controls.target.set(-5.46, 4.27, 1.39);
            controls.maxPolarAngle=.5*Math.PI
            return controls;
        }



        this.clearScene = () => {
            cancelAnimationFrame(scope.animateID);
            cancelAnimationFrame(scope.animationId);
            scope.scene.traverse((child) => {
                if (child.material) {
                    if (child.material.length > 1) {
                        for (let i = 0; i < child.material.length; i++) {
                            child.material.dispose();
                        }
                    } else {
                        child.material.dispose();
                    }
                }
                if (child.geometry) {
                    child.geometry.dispose();
                }
                child = null;
            });

            scope.renderer.forceContextLoss();
            scope.renderer.dispose();
            scope.scene.clear();
            scope.scene = null;
            scope.camera = null;
            scope.controls = null;
            scope.renderer.domElement = null;
            scope.labelRenderer_2d.domElement = null;
            scope.renderer = null;
            scope.sceneDomElement = null;
        }


        this.SetRenderAlpha = (visible) => {
            scope.renderer.alpha = visible;
        }


        this.ShowWorkShop = (visible) => {
            scope.WorkShop.visible = visible;
            scope.divLabel.forEach(item => {
                item.visible = !visible;
            });
        }

        function MoveCamera(CameraPos, TargetPos, time) {
            //console.log("MoveCamera");
            const tmpCamera = scope.camera.position;
            const tmpCtrl = scope.controls.target;
            scope.controls.enabled = false;
            var Cameratween = new TWEEN.Tween(tmpCamera)
                .to(CameraPos, time)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .start();
            var Ctrltween = new TWEEN.Tween(tmpCtrl)
                .to(TargetPos, time)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .start();
            var update = function () {

                scope.camera.position.set(tmpCamera.x, tmpCamera.y, tmpCamera.z);
                scope.controls.target.set(tmpCtrl.x, tmpCtrl.y, tmpCtrl.z);
                scope.camera.lookAt(scope.controls.target);

            };
            Cameratween.onUpdate(update);
            setTimeout(function () {
                scope.controls.enabled = true;
            }, time);
            return Cameratween;
        }

        /**
         * @烁滔老公
         * 渲染函数，每帧调用
         */
        function render() {
            scope.renderer.render(scope.scene, scope.camera);
            if (scope.composer) {
                scope.composer.render();
            }
        }

        /**
         * @乾斌宝宝
         * update函数
         * 每帧调用
         */
        function update() {
            render();
            TWEEN.update();
            scope.delta = scope.clock.getDelta();
            const timer = 0.0003 * Date.now();


            if (scope.ZincWater != null) {
                scope.ZincWater.material.uniforms['time'].value += 1.0 / 60.0;
            }
            if (scope.controls.enabled) {
                scope.controls.update();
            }
            if (scope.ConveyorBeltUV != null) {
                scope.ConveyorBeltUV.forEach(item => {
                    item.offset.y -= 0.01;
                });
            }

            if (scope.mixer) {
                scope.mixer.update(scope.delta);
            }

            if (!scope.isRoaming && !scope.isControls && !scope.isAloneModel) {
                scope.AnimationTime += scope.delta;
                if (scope.AnimationTime >= 10) {
                    scope.PlayCameraAnimation();
                    scope.AnimationTime = 0;

                }
            }

            scope.Intensity = Math.abs(Math.sin(timer)) * 2.5;
            if (scope.gangTieMaterial != null) {
                scope.gangTieMaterial.forEach(item => {
                    item.emissiveIntensity = scope.Intensity;
                });
            }
            scope.animateID = requestAnimationFrame(update);
        }

        //加载环境贴图
        function LoadSceneTexture() {
            scope.skyBox = new THREE.CubeTextureLoader().setPath('https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/vague/')
                .load([
                    "vague_01_left.png", // +x
                    "vague_01_right.png", // -x
                    "vague_01_up.png", // +y
                    "vague_01_down.png", // -y
                    "vague_01_front.png", // +z
                    "vague_01_back.png", // -z
                ], function onProgress(xhr) {
                    scope.scene.background = scope.skyBox;
                });

        }

        function LoadImg(imgName) {
            let img = new Image();
            img.src = "./img/" + imgName + ".png";
            img.onload = () => {
                scope.InfoBoxImg[imgName] = img;
            }
        }

        //加载反射贴图
        function LoadEnvironmentTexture() {
            scope.environment = new THREE.CubeTextureLoader().setPath('https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/forest/')
                .load([
                    "forest_left.png", // +x
                    "forest_right.png", // -x
                    "forest_up.png", // +y
                    "forest_down.png", // -y
                    "forest_front.png", // +z
                    "forest_back.png", // -z
                ]);
        }
    }

} export default ThreeDimensional;